import { createApp} from "vue"
import DashboardLayout from "./components/layouts/DashboardLayout.vue"
import EmptyLayout from "./components/layouts/EmptyLayout.vue"
import "./assets/tailwind.css"
import store from "@/store";
import VueClipboard from 'vue3-clipboard'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import Multiselect from "@vueform/multiselect";
import '@vueform/multiselect/themes/default.css'
import {BootstrapVue3} from 'bootstrap-vue-3'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import Toaster from "@meforma/vue-toaster";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { CkeditorPlugin } from '@ckeditor/ckeditor5-vue';

import App from "./App.vue"
import router from "./router"

const app = createApp(App)
app.component("default-layout", DashboardLayout)
app.component("empty-layout", EmptyLayout)
app.component('Datepicker', Datepicker)
app.component('Multiselect', Multiselect)
app.component('VueDatePicker', VueDatePicker)
app
  .use(router)
  .use(store)
  .use(BootstrapVue3)
  .use(CkeditorPlugin)
  .use(Toaster)
  .use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true,
  })

// 404/403 페이지에서 리다이렉트된 경우 처리
router.isReady().then(() => {
  const params = new URLSearchParams(window.location.search);
  const redirectParam = params.get("redirect");

  if (redirectParam) {
    params.delete("redirect");
    const redirect = decodeURIComponent(redirectParam);
    router.replace(redirect);
    return;
  }

  // 기존(sessionStorage) 방식도 지원
  const redirect = sessionStorage.getItem("redirect");
  if (redirect) {
    sessionStorage.removeItem("redirect");
    router.replace(redirect);
  }
});

app.mount("#app")

